const Person = ({ className = "", color }: { className?: string; color: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer1"
      d="M46.022 25.621c0 9.941-6.291 18.411-14.022 18.412s-14-8.059-14-18v-9.6C18 6.032 25.371 2 32 2c6.624 0 14.021 3.621 14.021 14.022z"
      fill={color}
    ></path>
    <path
      data-name="layer1"
      d="M50 51c-9.969-1.905-10-5-10-7v-3.336a11.757 11.757 0 0 1-8 3.37 11.937 11.937 0 0 1-8-3.239V44c0 2-1 5.188-11 7A13.366 13.366 0 0 0 2 62h60a15.541 15.541 0 0 0-12-11z"
      fill={color}
    ></path>
    <path
      data-name="opacity"
      d="M40 40.664a11.752 11.752 0 0 1-8 3.37 11.937 11.937 0 0 1-8-3.239V44c0 2-1 5.188-11 7A13.366 13.366 0 0 0 2 62h16.663L40 40.664z"
      fill="#000064"
      opacity=".2"
    ></path>
  </svg>
);

export default Person;
